<aside class="sidebar">
  <div class="sidebar-section">
    <h4 class="sidebar-heading">Contact</h4>
    @if (asset().owner_name) {
      <div class="sidebar-item">
        <span class="sidebar-label">Owner</span>
        <span class="sidebar-value">{{ asset().owner_name }}</span>
      </div>
      <div class="sidebar-divider"></div>
    }
    <div class="sidebar-item">
      <span class="sidebar-label">Technical Contact</span>
      <div class="sidebar-poc">
        <span class="sidebar-value">{{ asset().technical_contact_name }}</span>
        <a class="sidebar-email" [href]="'mailto:' + asset().technical_contact_email">{{
          asset().technical_contact_email
        }}</a>
      </div>
    </div>
  </div>
  @if (geographicalCoverageData()) {
    <div class="sidebar-section">
      <h4 class="sidebar-heading">Geographic Coverage</h4>
      <div class="geo-pills">
        @for (data of geographicalCoverageData(); track data) {
          <span class="geo-pill">
            <svg
              width="10"
              height="10"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <circle cx="12" cy="12" r="10" />
              <line x1="2" y1="12" x2="22" y2="12" />
              <path
                d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"
              />
            </svg>
            {{ data }}
          </span>
        }
      </div>
    </div>
  }
  @if (asset().sector_name) {
    <div class="sidebar-section">
      <h4 class="sidebar-heading">Sector</h4>
      <div class="theme-pills">
        <span class="theme-pill">{{ asset().sector_name }}</span>
      </div>
    </div>
  }
  @if (asset().themes?.length) {
    <div class="sidebar-section">
      <h4 class="sidebar-heading">Themes</h4>
      <div class="theme-pills">
        @for (theme of asset().themes!; track theme) {
          <span class="theme-pill">{{ theme }}</span>
        }
      </div>
    </div>
  }
</aside>
